import "./index.css";

const InvestorComplaints = () => {
  return (
    <div className="investor-complaints-container">
      <h2 className="investor-title">INVESTOR COMPLAINTS & QUERIES</h2>

      {/* Contact Section */}
      <div className="investor-contact">
        <h3>NUMBER AND DETAILS FOR CUSTOMER QUERIES/INVESTOR COMPLAINTS</h3>
        <p>
          <strong>Customer Support:</strong> (+92) 21-32622071-9
        </p>
        <p>
          <strong>Address:</strong> Suite 1101, 11th Floor, Trade Center, Near
          Jung Press, I.I Chundrigar Road, Karachi
        </p>
        <p>
          <strong>Telephone:</strong> (+92) 21-32622071-9
        </p>
        <p>
          <strong>WhatsApp:</strong> (+92) 333-5299121
        </p>
        <p>
          <strong>Email (Compliance):</strong>{" "}
          <a href="mailto:compliance@orbitsecurities.com.pk">
            compliance@orbitsecurities.com.pk
          </a>
        </p>
        <p>
          <strong>Email (Customer Support):</strong>{" "}
          <a href="mailto:css@orbitsecurities.com.pk">
            css@orbitsecurities.com.pk
          </a>
        </p>
      </div>

      {/* Pending Complaints */}
      <div className="investor-complaints">
        <h3>PENDING INVESTOR COMPLAINTS AGAINST BROKERAGE HOUSE</h3>
        <p>
          <strong>NIL</strong>
        </p>
      </div>

      {/* Complaints Process */}
      <div className="investor-complaints">
        <h3>COMPLAINT REFERRED TO CHIEF COMPLIANCE OFFICER</h3>
        <p>
          Whenever any client has a complaint in connection with any trade or
          transaction, they are advised to contact the Compliance Officer and
          submit their complaint in writing along with documentary evidence. The
          Compliance Department will ensure the resolution of the complaint in
          the shortest possible time in an amicable manner.
        </p>
      </div>

      {/* Arbitration Section */}
      <div className="investor-arbitration">
        <h3>DISPUTES TO BE REFERRED TO ARBITRATION</h3>
        <p>
          Whenever any dispute arises between Brokers, clients, or authorized
          agents in connection with any trade or transaction and is not
          otherwise settled amicably, it shall be referred to arbitration and
          dealt with according to the procedure laid down in Chapter 18 of the
          PSX Rule Book.
        </p>
      </div>

      {/* Arbitration Application */}
      <div className="investor-complaints">
        <h3>APPLICATION FOR ARBITRATION</h3>
        <p>
          If a dispute cannot be settled amicably, it must be referred to
          arbitration. Any party to the dispute may initiate arbitration by
          submitting a written application to the CRO. The applicant must
          provide the following:
        </p>
        <ul>
          <li>
            Claim Form duly filled and signed, along with all supporting
            documents.
          </li>
          <li>
            Undertaking to abide by all regulations for arbitration and the
            final award.
          </li>
        </ul>
        <p>For further details, refer to Chapter 18 of the PSX Rule Book.</p>
      </div>
    </div>
  );
};

export default InvestorComplaints;
